export default __webpack_public_path__ + "static/media/fil.e1eadad5.svg";